<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
        <div class="col-md-6 mb-2"></div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <ng-template #enviarTemplateEdit>
        <!-- GRILLA -->
        <div class="col-md-12" *ngIf="!selected">
            <div class="form-group col-md-12">
                <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
            </div>
            <br>
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                                [id]    ="DAT_AG_GRID.id" 
                                [class] ="DAT_AG_GRID.class" 
                                [ngStyle]="DAT_AG_GRID.style" 
                                [rowData]="rowData" 
                                [rowHeight]="DAT_AG_GRID.rowHeight"
                                [columnDefs]="columnDefs"
                                [pagination]="DAT_AG_GRID.pagination" 
                                [paginationPageSize]="DAT_AG_GRID.pagina"
                                [allowContextMenuWithControlKey]="true"
                                [frameworkComponents]="frameworkComponents" >
            </ag-grid-angular>
        </div>
        <!-- GRILLA [rowSelection]="rowSelectionPedidos"-->

        <div class="card mb-3 shadow-sm viaje-card" *ngIf="selected" style="border: 1px solid #f1e4c3; border-left: 5px solid #f0ad4e; border-radius: 8px;">
            <div class="card-body p-3" *ngIf="rowData">
                <div class="d-flex align-items-center justify-content-between flex-wrap mb-3 pb-2" style="border-bottom: 1px dashed #eadfc0;">
                    <div class="d-inline-flex align-items-center px-3 py-2" style="background:#fdf5e3; border-radius: 6px;">
                        <i class="fa fa-road" aria-hidden="true" style="color:#f0ad4e; font-size: 1.1rem;"></i>
                        <span class="ml-2 font-weight-bold" style="font-size: 1rem; margin-left: 8px;">Viaje # {{ selected?.idViaje }}</span>
                    </div>
                    <div class="d-inline-flex align-items-center px-3 py-2" style="background:#fdf5e3; border-radius: 6px;">
                        <i class="fa fa-lock" aria-hidden="true" style="color:#f0ad4e;"></i>
                        <span class="text-muted ml-2" style="font-size: 0.8rem; margin-left: 8px;">Sellos:</span>
                        <span class="font-weight-bold ml-2" style="font-size: 0.85rem; margin-left: 6px;">{{ selected?.sellos }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4 col-sm-6 d-flex align-items-start mb-3">
                        <div class="d-flex align-items-center justify-content-center mr-2" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                            <i class="fa fa-building" aria-hidden="true" style="color:#b0894a;"></i>
                        </div>
                        <div style="margin-left: 10px;">
                            <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Proveedor</div>
                            <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.proveedorNombre }}</div>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 d-flex align-items-start mb-3">
                        <div class="d-flex align-items-center justify-content-center mr-2" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                            <i class="fa fa-car" aria-hidden="true" style="color:#b0894a;"></i>
                        </div>
                        <div style="margin-left: 10px;">
                            <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Placa</div>
                            <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.placa }}</div>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 d-flex align-items-start mb-3">
                        <div class="d-flex align-items-center justify-content-center mr-2" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                            <i class="fa fa-user" aria-hidden="true" style="color:#b0894a;"></i>
                        </div>
                        <div style="margin-left: 10px;">
                            <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Nombre del Chofer</div>
                            <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.choferNombre }}</div>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 d-flex align-items-start mb-3">
                        <div class="d-flex align-items-center justify-content-center mr-2" style="width:38px; height:38px; background:#fdf5e3; border-radius:50%; flex-shrink:0;">
                            <i class="fa fa-phone" aria-hidden="true" style="color:#b0894a;"></i>
                        </div>
                        <div style="margin-left: 10px;">
                            <div class="text-muted text-uppercase" style="font-size: 0.7rem; letter-spacing: 0.5px;">Celular del Chofer</div>
                            <div class="font-weight-bold" style="font-size: 0.85rem;">{{ selected?.choferTelefono }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div><br> 
        
        <!-- FORMULARIO DE DOCUMENTOS  -->
        <div class="container-fluid" *ngIf="selected">
            <div class="row">
                <div class="col-md-12">                    
                    <form [formGroup]="formDocumentos" mat-dialog-content class="p-3 border rounded shadow-sm position-relative" style="background:#fff; border-radius: 10px !important;">
                        <div *ngIf="loadingFlete" class="d-flex flex-column align-items-center justify-content-center"
                             style="position:absolute; top:0; left:0; right:0; bottom:0; background:rgba(255,255,255,0.75); z-index:10; border-radius:10px;">
                            <app-lfsa-loading-v2></app-lfsa-loading-v2>
                            <small class="text-muted mt-2">Consultando información del flete SAP...</small>
                        </div>
                        <div class="d-flex align-items-center mb-3 pb-2" style="border-bottom: 1px solid #e9ecef;">
                            <div class="d-flex align-items-center justify-content-center mr-2" style="width:42px; height:42px; background:#e7f0ff; border-radius:8px; flex-shrink:0;">
                                <i class="fa fa-file" aria-hidden="true" style="color:#2f6bd5; font-size:1.2rem;"></i>
                            </div>
                            <div style="margin-left:10px;">
                                <h5 class="mb-0" style="font-weight:600;">Asignar Documentación</h5>
                                <small class="text-muted">Complete la información del documento para su registro e impresión.</small>
                            </div>
                        </div>

                        <div class="p-3 mb-3" style="border:1px solid #e9ecef; border-radius:8px;">
                            <h6 class="mb-3" style="color:#2f6bd5; font-weight:600;">
                                <i class="fa fa-file-text-o mr-1" aria-hidden="true"></i> 1. Información del Documento
                            </h6>
                            <div class="row" style="font-size: smaller">
                                <div class="col-md-4">
                                    <app-lfsa-input formControlName="fleteSap" [label]="'* N# flete SAP'" [id]="'fleteSap'"
                                        [control]="formDocumentos.get('fleteSap')" [type]="'text'" class="form-control-sm" (change)="getFleteDataSap()">
                                    </app-lfsa-input>
                                </div>
                                <div class="col-md-8 form-control-sm">
                                    <label for="familiaMaterial">* Familia Material (máx. 300 caracteres)</label>
                                    <textarea rows="4" style="font-size: smaller" formControlName="familiaMaterial" name="familiaMaterial"
                                        class="form-control ng-pristine ng-invalid ng-touched" maxlength="300">
                                    </textarea>
                                </div>
                                <div class="col-md-4 form-control-sm">
                                    <label for="notaExpedicion">* Nota de Expedición - Entregas (máx. 300 caracteres)</label>
                                    <textarea rows="4" style="font-size: smaller"
                                        maxlength="300" formControlName="notaExpedicion" name="notaExpedicion"
                                        class="form-control ng-pristine ng-invalid ng-touched">
                                    </textarea>
                                </div>
                                <div class="col-md-4">
                                    <app-lfsa-input formControlName="fletePesoNeto" [label]="'* Peso Neto'" [id]="'fletePesoNeto'"
                                        [control]="formDocumentos.get('fletePesoNeto')" [type]="'text'" class="form-control-sm">
                                    </app-lfsa-input>
                                </div>
                                <div class="col-md-4">
                                    <app-lfsa-input formControlName="fletePesoBruto" [label]="'* Peso Bruto'" [id]="'fletePesoBruto'"
                                        [control]="formDocumentos.get('fletePesoBruto')" [type]="'text'" class="form-control-sm">
                                    </app-lfsa-input>
                                </div>
                            </div>
                        </div>

                        <div class="p-3 mb-3" style="border:1px solid #e9ecef; border-radius:8px;">
                            <h6 class="mb-3" style="color:#2f6bd5; font-weight:600;">
                                <i class="fa fa-map-marker mr-1" aria-hidden="true"></i> 2. Información Logística
                            </h6>
                            <div class="row" style="font-size: smaller">
                                <div class="col-md-4 form-control-sm">
                                    <label for="guiaRemision">* Guía de remisión</label>
                                    <textarea rows="4" style="font-size: smaller" class="form-control"
                                        formControlName="guiaRemision" id="guiaRemision" name="guiaRemision" maxlength="300">
                                    </textarea>
                                    <app-lfsa-error-msg [control]="formDocumentos.get('guiaRemision')" [label]="'* Guia de remision'"></app-lfsa-error-msg>
                                </div>
                                <div class="col-md-4" style="display:none;">
                                    <app-lfsa-input formControlName="destino" [label]="'* Destino'" [id]="'destino'"
                                        [control]="formDocumentos.get('destino')" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                                    </app-lfsa-input>
                                </div>
                                <div class="col-md-4">
                                    <app-lfsa-input formControlName="detalleDestino" [label]="'* Destino'" [id]="'detalleDestino'"
                                        [control]="formDocumentos.get('detalleDestino')" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                                    </app-lfsa-input>
                                </div>
                                <div class="col-md-4">
                                    <app-lfsa-combo-box [label]="'* Centro Carga Origen'" formControlName="centroOrigen" [control]="formDocumentos.get('centroOrigen')"
                                                        [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm"
                                                        (change)="getAlmacen();" [isReadOnly]="true">
                                    </app-lfsa-combo-box>
                                </div>
                            </div>
                        </div>

                        <div class="p-3 mb-3" style="border:1px solid #e9ecef; border-radius:8px;">
                            <h6 class="mb-3" style="color:#2f6bd5; font-weight:600;">
                                <i class="fa fa-home mr-1" aria-hidden="true"></i> 3. Origen de la Carga
                            </h6>
                            <div class="row align-items-center" style="font-size: smaller">
                                <div class="col-md-4">
                                    <app-lfsa-combo-box [label]="'* Bodega / Carga Origen'" formControlName="agenciaOrigen" [control]="formDocumentos.get('agenciaOrigen')"
                                                        [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm"
                                                        [isReadOnly]="true">
                                    </app-lfsa-combo-box>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-check form-switch align-middle mt-3">
                                        <input class="form-check-input" id="esRegistro" type="checkbox" formControlName="esRegistro" role="switch">
                                        <label class="form-check-label" for="esRegistro">Es parte del registro a imprimir</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-3" style="background:#f8f9fb; border-radius:8px;">
                            <button (click)="addDocumento()" class="btn btn-primary">
                                <i aria-hidden="true" class="fa fa-check"></i> Agregar Documento
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <!--TABLA -->
            <div class="row my-4 border rounded">
                <div class="mb-3 bg-body-secondary text-center" *ngIf="listDocumentos.length == 0">  Sin detalles </div>
                <div *ngIf="listDocumentos.length > 0">
                    <table class="table table-sm table-hover" style="font-size: smaller">
                        <thead><tr>
                            <th *ngFor="let cab of tablaCelds">{{ cab.valor }}</th> 
                            <th></th>
                        </tr></thead>
                        <tbody>
                            <tr *ngFor="let item of listDocumentos">                            
                            <td>{{ item.fleteSap }}</td>
                            <td>{{ item.guiaRemision }}</td>
                            <td>{{ item.centroOrigen }}</td>
                            <td>{{ item.agenciaOrigen }}</td>
                            <td>{{ item.fletePesoNeto }}</td>
                            <td>{{ item.fletePesoBruto }}</td>
                            <td>{{ item.esRegistro }}</td>
                            <td><button (click)="deleteDocumento(item.id)" class={{DAT_BTNCSS.danger}}> X </button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button type="button" (click)="imprimirCheckInterno()" class="btn btn-block btn-info m-3 col-md-4"> <i aria-hidden="true" class="fa fa-print"></i> Imprimir </button>
            </div>
            
            <!-- FROM CARGA -->
            <div class="row border rounded">
                <form [formGroup]="formCarga" mat-dialog-content class="col-md-12 p-3">                                        
                    <div class="row">
                        <h6>Asignar detalle de Carga </h6><br>
                        <div class="col">
                            <div class="form-group">
                                <label for="tipo">Tipos</label>
                                <select class="form-control" formControlName="tipo">
                                    <option value="">-- Seleccione --</option>
                                    <option value="Pallet">Pallet</option>
                                    <option value="Envase">Envase</option>
                                    <option value="Material de empaque">Material de empaque</option>
                                    <option value="3PL">3PL</option>
                                </select>
                                <!--
                                <small *ngIf="formCarga.controls['tipo'].errors && formCarga.controls['tipo'].touched" class="text-danger">*Este campo es inválido</small>
                                -->
                            </div>
                        </div>
                        <div class="col">
                            <app-lfsa-input formControlName="descripcion" [label]="'* Descripcion'" [id]="'descripcion'" 
                                [control]="formCarga.get('descripcion')"  [type]="'text'" class="form-control-sm">
                            </app-lfsa-input>
                        </div>
                        <div class="col"> 
                            <app-lfsa-input formControlName="cantidad" [label]="'* Cantidad'" [id]="'cantidad'" 
                                [control]="formCarga.get('cantidad')"  [type]="'number'" class="form-control-sm">
                            </app-lfsa-input>
                        </div>
                        <div class="col">
                            <label> </label>
                            <button type="button" (click)="saveDetalleCarga()" class="btn btn-block btn-primary"> <i aria-hidden="true" class="fa fa-check"></i> Agregar </button>
                        </div>   
                    </div>             
                </form>
            </div>            
            <!--TABLA CARGA -->
            <div class="row my-4 border rounded">
                <div class="mb-3 bg-body-secondary text-center" *ngIf="listadoCargas.length == 0"> Sin detalles </div>
                <div *ngIf="listadoCargas.length > 0">
                    <table class="table table-sm table-hover" style="font-size: smaller">
                        <thead><tr>
                            <th>Tipo</th><th>Descripcion</th><th>Cantidad</th><th></th>
                        </tr></thead>
                        <tbody>
                            <tr *ngFor="let item of listadoCargas">
                            <td>{{ item.tipo }}</td>
                            <td>{{ item.descripcion }}</td>
                            <td>{{ item.cantidad }}</td>
                            <td><button (click)="deleteCargas(item.id)" class={{DAT_BTNCSS.danger}}> X </button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row col">
                <button (click)="acciones('regresar')" class="btn btn-outline-danger btn-block col-4">
                    <i class="fas fa-arrow-left"></i> Regresar
                </button>
                <div class="col-md-4"> </div>
                <button (click)="actualizarEstado()" [disabled]="listDocumentos.length === 0" class="btn btn-success btn-block col-4">
                    <i class="fas fa-save"></i> Finalizar y enviar a Balanza 
                </button>
            </div>      

        </div>

    </ng-template>
  </div>
  
    <!-- MODAL 
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>
  
    <ng-template #abrirModal>
        <div class="container-fluid">
        <form [formGroup]="formulario" mat-dialog-content>
            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="idViaje" [label]="'ID Viaje '" [id]="'idViaje'" 
                        [isReadOnly]="true" [control]="formulario.get('idViaje')" [type]="'number'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Seleccione Tipo'" formControlName="tipo" [control]="formulario.get('tipo')" 
                                        [comboBox]="listTipos" [opcion]="'nombre'" [idOpcion]="'idTipo'" [habilitar]="!isCreate" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="placa" [label]="'* Placa'" [id]="'placa'" [control]="formulario.get('placa')" 
                    (change)="getPlaca();" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="furgon" [label]="'* Furgon'" [id]="'furgon'" [control]="formulario.get('furgon')" 
                    [type]="'text'" class="form-control-sm" (change)="getPlaca(false)" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="detalleFurgon" [label]="'* Detalle Furgon'" [id]="'detalleFurgon'" [control]="formulario.get('detalleFurgon')" 
                    [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="proveedorId" [label]="'* Código proveedor'" [id]="'proveedorId'" [control]="formulario.get('proveedorId')" 
                    [placeholder]="'Código proveedor'" (change)="getProveedor();" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="proveedorNombre" [label]="'* Detalle proveedor'" [id]="'proveedorNombre'" [control]="formulario.get('proveedorNombre')" 
                    [placeholder]="'Nombre proveedor'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="choferCedula" [label]="'* Cédula chofer'" [id]="'choferCedula'" [control]="formulario.get('choferCedula')" 
                    [placeholder]="'Ingrese cédula del chofer (sin - u otros simbolos)'" (change)="getChofer();" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="choferNombre" [label]="'* Detalle chofer'" [id]="'choferNombre'" [control]="formulario.get('choferNombre')" 
                    [placeholder]="'Nombre chofer'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                    </app-lfsa-input>
                </div>
                <div class="col">
                    <app-lfsa-input formControlName="choferTelefono" [label]="'* Télefono chofer'" [id]="'choferTelefono'" [control]="formulario.get('choferTelefono')" 
                    [placeholder]="'Télefono chofer'" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Seleccione Centro Destino'" formControlName="centroDestino" [control]="formulario.get('centroDestino')" 
                                        [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Seleccione Centro Carga Origen'" formControlName="centroOrigen" [control]="formulario.get('centroOrigen')" 
                                        [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" (change)="getAlmacen();" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
                <div class="col">
                    <app-lfsa-combo-box [label]="'* Seleccione Bodega/Carga Origen'" formControlName="agenciaOrigen" [control]="formulario.get('bodegaCarga')" 
                                        [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm" >
                    </app-lfsa-combo-box>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <label for="fechaLlegada" style="font-size: .875rem;">Fecha y hora planificada de llegada</label>
                    <input autocomplete="off" class="form-control" formControlName="fechaLlegada" 
                    id="fechaLlegada" name="fechaLlegada" type="datetime-local" min="2025-01-01T00:00" max="2030-12-31T00:00" />
                    <small *ngIf="this.formulario.get('fechaLlegada')?.hasError('required') && this.formulario.get('fechaLlegada').touched" 
                    class="text-danger">*Campo obligatorio</small>
                </div>

                <div class="col">
                    <app-lfsa-combo-box [label]="'* Estado '" formControlName="estado" [control]="formulario.get('estado')" 
                                        [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" [habilitar]="true" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
            </div>
            
            <app-lfsa-botones-formulario
                (devolverAccion) ="acciones($event)" 
                [formularioValido] ="formulario.invalid" 

                [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
            </app-lfsa-botones-formulario>
        </form>
        </div>
    </ng-template> -->
    <!-- END MODAL --> 